import React, {Component} from 'react';
import './assets/scss/app.css';
import {Switch, Route, Redirect} from "react-router-dom";
import Login from "./containers/Login/Login";
import PrivateRoute from "./components/common/PrivateRoute";
import Dashboard from "./containers/Dashboard/Dashboard";
import Warehouses from "./containers/Warehouses/Warehouses";
import Users from "./containers/Users/Users";
import AccountInformation from "./containers/AccountInformation/AccountInformation";
import Notifications from "./containers/Notifications/Notifications";
import ResetPassword from "./containers/ResetPassword/ResetPassword";
import WarehouseDetails from "./containers/WarehouseDetails/WarehouseDetails";
import SingleWarehouse from "./containers/Warehouses/Warehouse";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import AcceptInvitation from "./containers/AcceptInvitation/AcceptInvitation";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotFound from "./components/NotFound/NotFound";
import 'react-big-calendar/lib/css/react-big-calendar.css';

class App extends Component {
  render() {
    return (
        <div className="App">
          <Switch>
            <PrivateRoute exact auth={this.props.auth} path="/warehouses/:id/edit" component={WarehouseDetails}/>
            <PrivateRoute exact auth={this.props.auth} path="/warehouses/:id" component={SingleWarehouse}/>
            <PrivateRoute exact auth={this.props.auth} path="/add-warehouse" component={WarehouseDetails}/>
            <PrivateRoute exact auth={this.props.auth} path="/dashboard" component={Dashboard}/>
            <PrivateRoute exact auth={this.props.auth} path="/warehouses" component={Warehouses}/>
            <PrivateRoute exact auth={this.props.auth} path="/users" component={Users}/>
            <PrivateRoute exact auth={this.props.auth} path="/account-information" component={AccountInformation}/>
            <PrivateRoute exact auth={this.props.auth} path="/notifications" component={Notifications}/>
            <Route exact path="/forgot-password" component={ResetPassword}/>
            <Route exact path="/reset-password/:resetKey" component={AcceptInvitation}/>
            <Route exact path="/login" component={Login}/>
            <Route exact path="/accept-invitation/:token" component={AcceptInvitation}/>
            <Route exact path="/" render={() => <Redirect to="/dashboard"/>}/>
            <Route component={NotFound}/>
          </Switch>
          <ToastContainer/>
        </div>
    );
  }
}

App.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js